import { render, staticRenderFns } from "./SaleCustomerDetail.vue?vue&type=template&id=6042f117&scoped=true&lang=pug"
import script from "./SaleCustomerDetail.vue?vue&type=script&lang=js"
export * from "./SaleCustomerDetail.vue?vue&type=script&lang=js"
import style0 from "./SaleCustomerDetail.vue?vue&type=style&index=0&id=6042f117&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6042f117",
  null
  
)

export default component.exports